// FAQ items — legitimate concierge business
export const faqs = [
  {
    id: 1,
    tr: {
      q: "Ne tür hizmetler sunuyorsunuz?",
      a: "Girne'de VIP misafirler için konsiyerj, tur rehberliği, otel rezervasyonu, restoran ve casino koordinasyonu, yat kiralama, havalimanı transferi ve etkinlik organizasyonu hizmetleri sunuyoruz.",
    },
    en: {
      q: "What services do you offer?",
      a: "We provide VIP concierge, tour guiding, hotel booking, restaurant and casino coordination, yacht charter, airport transfer and event organisation in Kyrenia.",
    },
  },
  {
    id: 2,
    tr: {
      q: "Rezervasyon nasıl yapılır?",
      a: "En hızlı yol WhatsApp üzerinden mesaj atmaktır. İhtiyacınızı ve tarihinizi belirtin — dakikalar içinde özel bir teklif alacaksınız.",
    },
    en: {
      q: "How do I make a reservation?",
      a: "The fastest way is to message us on WhatsApp. Share your needs and dates — you'll receive a bespoke proposal within minutes.",
    },
  },
  {
    id: 3,
    tr: {
      q: "Fiyatlandırmanız nasıl işliyor?",
      a: "Fiyatlar paket süresine, misafir sayısına ve seçilen hizmetlere göre değişir. Sabit tarife yerine kişiye özel teklif hazırlanır.",
    },
    en: {
      q: "How does pricing work?",
      a: "Pricing varies by package length, guest count and selected services. We prepare a bespoke quote instead of fixed rates.",
    },
  },
  {
    id: 4,
    tr: {
      q: "Hangi otellerle çalışıyorsunuz?",
      a: "Acapulco Resort, Merit Crystal Cove, Cratos Premium, Concorde Luxury, Lord's Palace, Kaya Artemis ve Girne'deki tüm 5 yıldızlı otellerde rezervasyon koordinasyonu sağlıyoruz.",
    },
    en: {
      q: "Which hotels do you work with?",
      a: "We coordinate reservations at Acapulco Resort, Merit Crystal Cove, Cratos Premium, Concorde Luxury, Lord's Palace, Kaya Artemis and every 5-star hotel in Kyrenia.",
    },
  },
  {
    id: 5,
    tr: {
      q: "Diskretlik nasıl garanti ediliyor?",
      a: "Kişisel bilgileriniz asla talep edilmez. WhatsApp mesajlarınız 24 saat içinde silinir. Tüm koordinasyon şifreli kanallar üzerinden yürütülür.",
    },
    en: {
      q: "How is discretion guaranteed?",
      a: "Personal information is never requested. WhatsApp messages are deleted within 24 hours. All coordination runs over encrypted channels.",
    },
  },
  {
    id: 6,
    tr: {
      q: "Hangi dillerde hizmet veriyorsunuz?",
      a: "Türkçe, İngilizce, Rusça, Almanca, Fransızca, İtalyanca, Arapça ve Ukraynaca konuşan ekip üyelerimiz mevcut.",
    },
    en: {
      q: "In which languages do you serve?",
      a: "Our team speaks Turkish, English, Russian, German, French, Italian, Arabic and Ukrainian.",
    },
  },
  {
    id: 7,
    tr: {
      q: "Ne kadar önceden rezervasyon yapmalıyım?",
      a: "Kısa süreli koordinasyonlar (havalimanı transferi, restoran rezervasyonu) 2-3 saat öncesinden mümkündür. Yat, çoklu gün paketleri için 24-48 saat önceden öneririz.",
    },
    en: {
      q: "How far in advance should I book?",
      a: "Short-notice coordination (airport transfer, restaurant reservation) is possible 2–3 hours in advance. For yacht and multi-day packages, we recommend 24–48 hours ahead.",
    },
  },
  {
    id: 8,
    tr: {
      q: "Grup rezervasyonları / kurumsal etkinlikler için de destek veriyor musunuz?",
      a: "Evet. Kurumsal etkinlikler, iş toplantıları, doğum günü ve bekarlığa veda kutlamaları için özel paketlerimiz vardır. WhatsApp üzerinden detaylı görüşelim.",
    },
    en: {
      q: "Do you support group reservations / corporate events?",
      a: "Yes. We offer bespoke packages for corporate events, business meetings, birthdays and bachelor celebrations. Let's discuss details on WhatsApp.",
    },
  },
  {
    id: 9,
    tr: {
      q: "Girne night club rezervasyonu nasıl yapılır?",
      a: "Girne night club rezervasyonu için tarihinizi, misafir sayınızı ve tercih ettiğiniz mekanı WhatsApp üzerinden bildirin. Cratos, Merit, Acapulco kompleksi içindeki lisanslı sahne kulüpleri ve şehir merkezindeki butik night club'lar dahil tüm mekanlarda VIP masa, öncelikli giriş ve bottle service (Dom Pérignon, Cristal) koordinasyonu sağlıyoruz. Cabaret ve sahne şovu gecelerine özel paket seçenekleri mevcuttur.",
    },
    en: {
      q: "How do I book a Kyrenia nightclub?",
      a: "Send us your date, guest count and preferred venue on WhatsApp. We coordinate VIP tables, priority entry and bottle service (Dom Pérignon, Cristal) at every venue — from licensed stage clubs within Cratos, Merit and Acapulco complexes to downtown boutique nightclubs. Bespoke packages for cabaret and stage-show nights available.",
    },
  },
  {
    id: 10,
    tr: {
      q: "Girne'de rezidans veya konsept ev kiralamak ile otel arasındaki fark nedir?",
      a: "Otel süiti kısa kalışlar için idealken, rezidans ve konsept ev seçenekleri 3+ gün konaklamalar veya çoklu misafir grupları için daha uygundur. Rezidansta tam donanımlı mutfak, günlük ev temizliği, özel park yeri ve özel havuz seçenekleri bulunur. Konsept ev genellikle 2-6 yatak odalı, deniz manzaralı ve tamamen mahremdir. Girne'de Karaoğlanoğlu, Alsancak ve marina bölgelerinde alternatiflerimiz vardır. VIP paketlerde özel şef, günlük çiçek servisi ve şampanya karşılaması dahildir.",
    },
    en: {
      q: "What's the difference between renting a residence/concept house in Kyrenia and a hotel?",
      a: "A hotel suite is ideal for short stays; residence and concept-house options fit better for 3+ night stays or multi-guest groups. A residence includes a fully equipped kitchen, daily housekeeping, private parking and optional private pool. A concept house is typically 2–6 bedrooms, sea-view and fully private. We have alternatives in Karaoğlanoğlu, Alsancak and marina areas of Kyrenia. VIP packages add a private chef, daily flower service and champagne welcome.",
    },
  },
  {
    id: 11,
    tr: {
      q: "Cabaret ve aerial silk sahne şovu nedir? Girne'de nerede izlenebilir?",
      a: "Cabaret geceleri koreografili sahne performansları, canlı sahne müziği ve şampanya töreni ile klasik gece kulübü deneyimidir. Aerial silk performansı ise Cirque du Soleil estetiğinde havai gösterilerdir. Girne'nin lisanslı sahne kulüplerinde (Cratos, Merit, Acapulco kompleksleri) düzenli olarak sunulur. Kıbrıs Night Club bu gösteriler için VIP masa rezervasyonu, öncelikli giriş ve bottle service koordinasyonu yapar. Bekarlığa veda ve doğum günü için özel paket seçenekleri mevcuttur.",
    },
    en: {
      q: "What are cabaret and aerial silk stage shows? Where can I watch them in Kyrenia?",
      a: "Cabaret nights are a classic nightclub experience with choreographed stage performances, live stage music and a champagne ritual. Aerial silk performances are Cirque du Soleil-style aerial shows. They're regularly presented at Kyrenia's licensed stage clubs (within Cratos, Merit and Acapulco complexes). Kıbrıs Night Club coordinates VIP table reservations, priority entry and bottle service for these shows. Bespoke package options for bachelor and birthday celebrations available.",
    },
  },
  {
    id: 12,
    tr: {
      q: "Kıbrıs gece hayatı hangi saatler arasında aktif?",
      a: "Girne gece hayatı akşam 22:00 civarında başlayıp sabah 05:00'e kadar aktiftir. Beach club gündüz partileri 12:00–18:00, cocktail bar ve rooftop terrace 18:00–01:00, gece kulüpleri ve cabaret salonları 22:00–05:00 arası hizmet verir. VIP masa rezervasyonu ve öncelikli giriş için 24 saat önceden koordinasyon öneririz. Kıbrıs Night Club 7/24 ulaşılabilir — kısa süreli rezervasyonlarda 2-3 saat öncesinden de destek verebiliriz.",
    },
    en: {
      q: "What are the hours of Cyprus nightlife?",
      a: "Kyrenia nightlife starts around 22:00 and runs until 05:00. Beach-club day parties run 12:00–18:00, cocktail bars and rooftop terraces 18:00–01:00, nightclubs and cabaret venues 22:00–05:00. For VIP tables and priority entry we recommend coordinating 24 hours in advance. Kıbrıs Night Club is available 24/7 — short-notice reservations at 2–3 hours in advance are also supported.",
    },
  },
];
